import { render, staticRenderFns } from "./DnsChallengePopover.vue?vue&type=template&id=d5737b34&scoped=true"
import script from "./DnsChallengePopover.vue?vue&type=script&lang=js"
export * from "./DnsChallengePopover.vue?vue&type=script&lang=js"
import style0 from "./DnsChallengePopover.vue?vue&type=style&index=0&id=d5737b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5737b34",
  null
  
)

export default component.exports